import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { PropTypeBn } from '@blockcatio/tabby-library/lib/utilities/PropTypeBn';

import AccountInfo from './AccountInfo';
import PaymentList from './PaymentList';
import CurrencySelectorContainer from './CurrencySelector';
// eslint-disable-next-line import/no-named-as-default
import PaymentFormContainer from './PaymentFormContainer';

const Dashboard = ({
  currentAddress,
  balance,
  acceptPayment,
  cancelPayment,
  onPaymentRemove,
  payments,
  onError,
  catBalance,
  recommendedGasPrices,
  networkName,
  formattedTokenBalance,
  tokenSymbol,
  onWalletChange,
  notify,
  formatPaymentAmount,
  paymentsFetching,
  catTokenContractAddress,
  tokenAddress,
}) => (
  <div className="dashboard">
    <CurrencySelectorContainer />

    <div className="row main">
      <div className="col l8 s12">
        <PaymentFormContainer />
      </div>

      <div className="col l4 s12">
        <AccountInfo
          address={currentAddress}
          balance={balance}
          networkName={networkName}
          onWalletChange={onWalletChange}
          catBalance={catBalance}
          // If the token is CAT, don't send in the formatted balance.
          formattedTokenBalance={
            catTokenContractAddress === tokenAddress ? null : formattedTokenBalance
          }
          tokenSymbol={tokenSymbol}
        />
      </div>
    </div>

    <div className="row">
      <div className="col s12">
        <PaymentList
          className="payment-history"
          heading="Payments"
          emptyText="You have not sent or received any payments."
          payments={payments}
          acceptPayment={acceptPayment}
          cancelPayment={cancelPayment}
          onPaymentRemove={onPaymentRemove}
          recommendedGasPrice={recommendedGasPrices.standard}
          notify={notify}
          onError={onError}
          formatPaymentAmount={formatPaymentAmount}
          paymentsFetching={paymentsFetching}
        />
      </div>
    </div>
  </div>
);

Dashboard.defaultProps = {
  currentAddress: '',
  balance: null,
  acceptPayment: () => Promise.resolve(''),
  cancelPayment: () => Promise.resolve(''),
  onPaymentRemove: noop,
  payments: [],
  // eslint-disable-next-line no-console
  onError: error => console.error(error),
  catBalance: null,
  recommendedGasPrices: {},
  networkName: '',
  formattedTokenBalance: null,
  tokenSymbol: '',
  onWalletChange: noop,
  notify: noop,
  formatPaymentAmount: noop,
  paymentsFetching: false,
  catTokenContractAddress: '',
  tokenAddress: '',
};

Dashboard.propTypes = {
  currentAddress: PropTypes.string,
  balance: PropTypeBn,
  acceptPayment: PropTypes.func,
  cancelPayment: PropTypes.func,
  onPaymentRemove: PropTypes.func,
  // eslint-disable-next-line react/no-typos
  payments: PaymentList.propTypes.payments,
  onError: PropTypes.func,
  catBalance: PropTypeBn,
  recommendedGasPrices: PropTypes.objectOf(PropTypes.number),
  networkName: PropTypes.string,
  formattedTokenBalance: PropTypes.node,
  tokenSymbol: PropTypes.string,
  onWalletChange: PropTypes.func,
  notify: PropTypes.func,
  formatPaymentAmount: PropTypes.func,
  paymentsFetching: PropTypes.bool,
  catTokenContractAddress: PropTypes.string,
  tokenAddress: PropTypes.string,
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js